export default "__VITE_ASSET__4bcfe4e3__"